import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.js';

// Service worker unregistration code
// This will remove any previously registered service workers
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    for (let registration of registrations) {
      registration.unregister();
      console.log('Service worker unregistered');
    }
  }).catch(error => {
    console.error('Service worker unregistration failed:', error);
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);
